<template lang="html">
  <div class="evaluate-list">
    <postItem
      v-for="exp in items"
      :ommitContent="true"
      :experience="exp"
      :key="exp.id"
      :imgLog="true"
    ></postItem>
  </div>
</template>

<script>
import postItem from './item-experience'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    postItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
</style>
